export const createLatLng = (lat: number, lng: number): google.maps.LatLng => {
  return new google.maps.LatLng(lat, lng);
};

export const getAddressComponent = (
  place: google.maps.places.PlaceResult,
  componentType: string
): string => {
  const component = place.address_components?.find(
    (component) => component.types.indexOf(componentType) > -1
  );
  return component ? component.long_name : '';
};

export const formatAddress = (place: google.maps.places.PlaceResult): string => {
  const streetNumber = getAddressComponent(place, 'street_number');
  const street = getAddressComponent(place, 'route');
  const city = getAddressComponent(place, 'locality');
  const state = getAddressComponent(place, 'administrative_area_level_1');
  const country = getAddressComponent(place, 'country');

  return `${streetNumber} ${street}, ${city}, ${state}, ${country}`.trim();
};